module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[36]35.882b330.woff2";